













import { Component, Vue, Watch } from 'vue-property-decorator'
import { State } from 'vuex-class'
import PagContainer from '@/components/pagContainer.vue'
import { $fetchPag } from '@/api'
import { highlightList, atmospherePag, totoalStation } from '@/utils/config'
let decoratePagSrc =
  '//i0.hdslb.com/bfs/ogv/activity/film-history/decorate-1.pag'

const highlight = [40, 41, 41, 44]
@Component({
  components: {
    PagContainer,
  },
})
export default class Stage extends Vue {
  @State('pagIns') pagIns
  @State('currPoint') currPoint
  pagFile: any
  decoratePagSrc = decoratePagSrc
  nextLoadPoint = 1
  pagFileList = []
  decorateRef = null

  @Watch('currPoint')
  watchCurrPointChange(newVal) {
    if (newVal === totoalStation) {
      let decoratePagIns: any = this.$refs['decorateRef']
      let pagFile = decoratePagIns && decoratePagIns.getPagFile()
      pagFile && pagFile.setVisible(false)
      return false
    }
    // 高光时刻去除氛围
    let currInx = highlightList.findIndex((item) => item.station === newVal)
    if (currInx !== -1) {
      let pagInx = highlight[currInx]
      this.decoratePagSrc = `//i0.hdslb.com/bfs/ogv/activity/film-history/decorate-${pagInx}.pag`
    } else {
      if (newVal >= 1) {
        let currInx = highlightList.findIndex((item) => item.station >= newVal)
        let srcInx = currInx === -1 ? newVal - 4 : newVal - currInx
        if (srcInx > 0 || srcInx <= atmospherePag) {
          this.decoratePagSrc = `//i0.hdslb.com/bfs/ogv/activity/film-history/decorate-${srcInx}.pag`
        }
      }
    }
  }

  // 下载pag文件并且返回file文件
  async loadPagFile(url: string) {
    return await $fetchPag(url)
      .then(async (response) => {
        return response.data
      })
      .catch((err) => {
        console.log('%c err123 ------> ', 'color:#0f0;', err)
      })
  }

  handlePagReady() {
    console.log('%c handlePagReady ------> ', 'color:#0f0;', 111111)
    let padIns: any = this.$refs['decorateRef']
    padIns && padIns.onPlay()
  }
}
